// extracted by mini-css-extract-plugin
export var actions = "_tt-4";
export var item = "_tt-1";
export var price = "_tt-3";
export var quantity = "_tt-2";
export var table = "_tt-0";